import { statsConfigSelectors } from '~/redux/ducks/config';
import { commonMessages } from '~/utility/commonMessages';

const formatTitle = (intl, filterName, reportCategory) => {
    if (filterName === 'shootsCatches') {
        const shootCatchesMessage =
            reportCategory === 'goalie' ? commonMessages.filters.catches : commonMessages.filters.shoots;
        return intl.formatMessage(shootCatchesMessage);
    }
    return intl.formatMessage(commonMessages.filters[filterName]);
};

const formatValueForBreadcrumb = (intl, statsConfig, filterName, value) => {
    let formattedValue = value;

    if (filterName === 'opponent') {
        const [grouping, id] = value.split('.');
        if (grouping === 'franchise') {
            formattedValue = statsConfigSelectors.getFranchiseName(statsConfig, id);
        } else {
            formattedValue = intl.formatMessage(commonMessages.advancedFilters[`${grouping}.${id}`]);
        }
    } else if (filterName === 'status') {
        formattedValue = intl.formatMessage(commonMessages.playerStatusValues[value]);
    } else if (filterName === 'isRookie') {
        formattedValue = intl.formatMessage(commonMessages.experienceValues[value]);
    } else if (filterName === 'nationalityCode') {
        formattedValue = statsConfig.countryData.filter((x) => x.id === value)[0].country3Code;
    }

    // We will display the full translation when the language code is not English
    if (window.__SITE_LANGUAGE_CODE__ !== 'en') {
        if (filterName === 'decision') {
            formattedValue = intl.formatMessage(commonMessages.experienceValues[value]);
        } else if (filterName === 'shootsCatches') {
            formattedValue = intl.formatMessage(commonMessages.handDominanceValues[value]);
        } else if (filterName === 'homeRoad') {
            formattedValue = intl.formatMessage(commonMessages.homeRoadValues[value]);
        } else if (filterName === 'birthStateProvinceCode') {
            // We can just show the abbreviation for English
            const stateProvinces = statsConfig.countryData.flatMap((x) => x.stateProvinces);
            formattedValue = stateProvinces.filter((x) => x.id === value)[0].stateProvinceName;
        }
    }

    return formattedValue;
};

// We want to maintain the existing order of breadcrumbs, and only keep the active filters
const getBreadcrumbs = (existingBreadcrumbs, activeFilters) => {
    const activeFilterKeys = Object.keys(activeFilters);
    if (!activeFilterKeys.length) {
        return [];
    }

    const updatedFilters = existingBreadcrumbs
        .map((obj) => {
            const [name] = Object.keys(obj);
            return name;
        })
        .filter((name) => activeFilterKeys.includes(name))
        .map((name) => ({ [name]: activeFilters[name] }));

    const existingFilterNames = existingBreadcrumbs.map((obj) => {
        const [name] = Object.keys(obj);
        return name;
    });
    const newFilters = Object.keys(activeFilters)
        .filter((key) => !existingFilterNames.includes(key))
        .map((key) => ({ [key]: activeFilters[key] }));

    return updatedFilters.concat(newFilters);
};

const createBreadcrumbMap = (breadcrumbs) => {
    const breadcrumbMap = {};
    breadcrumbs.map((breadcrumb) => {
        Object.keys(breadcrumb).map((key) => (breadcrumbMap[key] = breadcrumb[key]));
    });
    return breadcrumbMap;
};

const didActiveFiltersChange = (prevFilters, nextFilters) => {
    const didNumFiltersChange = Object.keys(prevFilters).length !== Object.keys(nextFilters).length;

    const didFilterNamesChange = Object.keys(nextFilters).some((key) => !Object.keys(prevFilters).includes(key));

    const didFilterValuesChange = Object.values(nextFilters).some((val) => !Object.values(prevFilters).includes(val));

    return didNumFiltersChange || didFilterNamesChange || didFilterValuesChange;
};

export default {
    formatTitle,
    formatValueForBreadcrumb,
    getBreadcrumbs,
    createBreadcrumbMap,
    didActiveFiltersChange,
};
